import { setUserActivity } from './UserActions';

// App
export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    socket.on('user/activity/pong', data => {
        if(!getUser() || (data.user !== (getUser() || {})._id && data.roles.includes((getUser() || {}).role))) {
            dispatch(setUserActivity(data.user));
        }
    });
}
